import { defineMessages } from 'react-intl';

export default defineMessages({
  productsToReturnTitlePage: {
    id: 'view.myaccount.step.productsToReturn.productsToReturnTitlePage',
    defaultMessage: 'Products to return',
  },
});
